<template>
  <div class="mb-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
    <!-- Productos por vencer -->
    <div class="relative bg-amber-500 w-full rounded-xl px-5 py-5 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden min-h-[120px]" style="background-color:#f59e0b;">
      <div class="absolute top-4 right-4 opacity-20">
        <font-awesome-icon icon="fa-solid fa-clock" class="text-white" style="font-size: 48px;" />
      </div>
      <div class="relative z-10 pr-20">
        <div class="text-white text-xs font-semibold uppercase tracking-wide mb-1">Por vencer</div>
        <div class="text-white text-4xl font-bold">{{ productsToExpired }}</div>
      </div>
    </div>

    <!-- Productos vencidos -->
    <div class="relative bg-red-500 w-full rounded-xl px-5 py-5 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden min-h-[120px]" style="background-color:#ef4444;">
      <div class="absolute top-4 right-4 opacity-20">
        <font-awesome-icon icon="fa-solid fa-circle-xmark" class="text-white" style="font-size: 48px;" />
      </div>
      <div class="relative z-10 pr-20">
        <div class="text-white text-xs font-semibold uppercase tracking-wide mb-1">Vencidos</div>
        <div class="text-white text-4xl font-bold">{{ expiredProducts }}</div>
      </div>
    </div>

    <!-- Productos con stock mínimo -->
    <div class="relative bg-yellow-500 w-full rounded-xl px-5 py-5 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden min-h-[120px]" style="background-color:#eab308;">
      <div class="absolute top-4 right-4 opacity-20">
        <font-awesome-icon icon="fa-solid fa-triangle-exclamation" class="text-white" style="font-size: 48px;" />
      </div>
      <div class="relative z-10 pr-20">
        <div class="text-white text-xs font-semibold uppercase tracking-wide mb-1">Stock Mínimo</div>
        <div class="text-white text-4xl font-bold">{{ productsWhitMinimumStock }}</div>
      </div>
    </div>

    <!-- Productos agotados -->
    <div class="relative bg-rose-500 w-full rounded-xl px-5 py-5 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden min-h-[120px]" style="background-color:#f43f5e;">
      <div class="absolute top-4 right-4 opacity-20">
        <font-awesome-icon icon="fa-solid fa-ban" class="text-white" style="font-size: 48px;" />
      </div>
      <div class="relative z-10 pr-20">
        <div class="text-white text-xs font-semibold uppercase tracking-wide mb-1">Agotados</div>
        <div class="text-white text-4xl font-bold">{{ outOfStockProducts }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImportantReport",
  props: {
    expiredProducts: {
      type: Number,
      required: true
    },
    productsToExpired: {
      type: Number,
      required: true
    },
    productsWhitMinimumStock: {
      type: Number,
      required: true
    },
    outOfStockProducts: {
      type: Number,
      required: true
    }
  }
};
</script>
